import { getApi } from './../../../src/ts/libs/getApi';
/* eslint-disable no-shadow */
const newsContainer = document.getElementsByClassName('news-grid');
const loadMoreToggle = document.getElementById('load-more-posts');
let allPosts = [];
const postsPerPage = 6;
let page = 1;
const NEWS_API_URL = getApi('news');

if (newsContainer.length != 0) {
  fetch(NEWS_API_URL, {
    headers: { 'content-type': 'application/json' },
  })
    .then((response) => response.json())
    .then(function (newsApiData) {
      allPosts = newsApiData;
      const layout = mapPosts(newsApiData, page);
      newsContainer[0].innerHTML = layout;
    })
    .catch((e) => {
      console.error(e);
    });

  loadMoreToggle.addEventListener('click', () => {
    page = page + 1;
    const limit = postsPerPage * page;

    fetch(NEWS_API_URL, {
      body: JSON.stringify({ page }),
      headers: { 'content-type': 'application/json' },
    })
      .then((response) => response.json())

      .then(function (newsApiData) {
        allPosts = newsApiData;
        const layout = mapPosts(newsApiData, limit);
        newsContainer[0].innerHTML = layout;
      })
      .catch((e) => {
        console.error(e);
      });
  });
}

function mapPosts(data, page) {
  const end = postsPerPage * page;
  const splicedPosts = data.posts.splice(0, end);
  let posts = '';

  for (let i = 0; i < splicedPosts.length; i++) {
    const post = splicedPosts[i];

    const postTemplate = `
          <div class="card card--horizontal card--news">
              <div class="card__image">
                  <picture>
                  <img src="${post.imgSrc}" alt="">
                  </picture>
              </div>

              <div class="card__content">
                  <span class="card__content__tag">${post.tag}</span>
                  <h3 class="card__content__heading">
                      <a href="#">
                      ${post.heading}
                      </a>
                  </h3>
                  <h3 class="card__content__sub-heading">
                  ${post.subHeading}
                  </h3>
                  <div class="card__action">
                      <a href="#" class="button button--muted">
                          <span class="button__label">Read more</span>
                      </a>
                  </div>
              </div>
          </div>
          `;

    posts = posts + postTemplate;
  }

  return posts;
}

function loadMoreNews() {
  // get next 6 items

  const items = document.querySelectorAll<HTMLDivElement>('#js-news-items .card--news.is-hidden');

  if (items.length >= 1) {
    const toShow = Array.from(items).slice(0, items.length < 6 ? items.length : 6);

    toShow.forEach((item) => {
      // change data-src to src
      const img = item.querySelector<HTMLImageElement>('[data-src]');
      const src = img.getAttribute('data-src');
      img.setAttribute('src', src);
      // remove is-hidden class
      item.classList.remove('is-hidden');
    });
  }
  if (items.length < 6) {
    document.querySelector<HTMLButtonElement>('#js-load-more-news').classList.add('is-hidden');
  }
}

(function () {
  const newsTrigger = document.querySelector<HTMLButtonElement>('#js-load-more-news');

  if (newsTrigger) {
    newsTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      loadMoreNews();
    });
  }
})();
